<template>
  <b-row>
    <b-col class="col-12">
      <b-card class="bg-white overflow-hidden col-lg-6">
        <h2 class="text-center">
          {{ $t('Trade login') }}
        </h2>
        <b-form @submit="onSubmit">
          <b-form-group :label="$t('Email')" label-for="email-input">
            <b-form-input id="email-input" v-model="email" type="text" required />
          </b-form-group>
          <b-form-group :label="$t('Password')" label-for="pass-input">
            <b-form-input id="pass-input" v-model="password" type="password" required />
          </b-form-group>
          <div v-if="error" class="alert alert-danger">
            <span v-if="accountLocked">
              {{ $t('This account has been locked, to unlock the account please contact our account management team') }}
              <a href="https://www.boilerguide.co.uk/trade/contact/">{{ $t('here') }}</a>.
            </span>
            <span v-else>{{ errorMessage }}</span>
          </div>
          <div class="text-center d-flex flex-column">
            <b-button type="submit" variant="primary" size="sm" class="m-auto">
              {{ $t('Sign In') }}
            </b-button>
            <div class="pt-4 d-block m-auto">
              <router-link :to="{name:'forgot-password', params:{email}}" class="text-link font-weight-bold">
                {{ $t('Forgot your password?') }}
              </router-link>
            </div>
          </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "LogInForm",
  data: function() {
    return {
      email: this.$route.params.email ?? null,
      password: null,
      errorMessage: this.$t("Invalid credentials"),
      error: false,
    }
  },
  methods: {
    onSubmit: function(evt) {
      this.error = false;
      this.accountLocked = false;
      let app = this;
      evt.preventDefault();
      if (this.email.length > 0 && this.password.length > 0) {
        this.$store.dispatch('authenticate', {
          username: this.email,
          password: this.password,
        }).then(() => {
          const returnUrl = this.$route.query.to ?? {name: 'dashboard'};
          if (app.$store.state.USER_STATE === true) {
            app.$router.push(returnUrl);
          } else {
            app.error = true;
            if (app.$store.state.USER_ACCOUNT_LOCKED === true) {
              app.accountLocked = true;
            }
          }
        });
      }
    }
  },
  mounted: function() {
    let lang = this.$route.query.lang;
    if (lang) {
      this.$i18n.locale = lang;
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  box-shadow: 0 0 1.875rem rgba(0,0,0,.16);
  max-width: 576px;
  margin: -85px auto 0;
  border-radius: 48px;

  @include media-breakpoint-down(sm) {
    padding: 10px 25px 30px;
  }

  @include media-breakpoint-up(sm) {
    padding: 10px 60px 30px;
  }

  h2 {
    font-size: 36px;

    @include media-breakpoint-up(sm) {
      margin: 42px auto 35px;
    }

    @include media-breakpoint-down(sm) {
      margin: 20px auto 20px;
    }
  }
}

.text-link {
  color: $login-text-link;
}
</style>
